import React, {useEffect, useState} from 'react'
import {deleteSingleImage, updateSingleImage} from "../common/services/image-data-service";
import DeleteImage from "./delete-image";
import {useDownloadURL} from 'react-firebase-hooks/storage';
import {firebaseStorage, storageRef} from "../firebase/client-app";
import reactImageSize from 'react-image-size';
import ShowImage from "./show-image";
import {deleteSingleImageFile, deleteSingleImageThumbnailFile} from "../common/services/storage-file-data-service";
import EditImageDetail from "./edit-image-detail";
import _ from "lodash";
import {SAVE_IMAGE_DETAIL_TIME_DELAY} from "../common/constants/image.constant";

const ImageDetail = ({selectedImage, setSelectedImage, setSelectedImageRemoved, allTags, allThemes}) => {
    let [changesCount, setChangesCount] = useState(0);
    const [imageSize, setImageSize] = useState({width: 0, height: 0});

    const handleSelectImageChanges = async (event) => {
        const {name, value} = event.target;
        const existingImage = {...selectedImage};
        existingImage[name] = value;

        if (name === 'themeList') {
            const tempThemes = {};
            _.forEach(value, themeId => {
                tempThemes[themeId] = true;
            });

            existingImage['themes'] = tempThemes;
            existingImage['themeList'] = value;
        }

        if (name === 'tagList') {
            const allTags = {};
            _.forEach(value, tagId => {
                allTags[tagId] = true;
            });

            existingImage['tags'] = allTags;
            existingImage['tagList'] = value;
        }

        setSelectedImage(existingImage);
    }

    const removeImage = async () => {
        await deleteSingleImage(selectedImage);
        await deleteSingleImageFile(selectedImage);
        await deleteSingleImageThumbnailFile(selectedImage);
        setSelectedImageRemoved(true);
    }

    useEffect(() => {
        incrementChangesCount();
    }, [selectedImage]);

    useEffect(() => {
        const timeoutId =
            setTimeout(async () => {

                if (changesCount > 0) {
                    resetChangesCount();
                    saveImageDetailChanges();
                }

            }, SAVE_IMAGE_DETAIL_TIME_DELAY);

        return () => clearTimeout(timeoutId);
    }, [changesCount]);

    const saveImageDetailChanges = async () => {
        const existingImageDetail = {...selectedImage};

        if (!_.isEmpty(existingImageDetail)) {
            await updateSingleImage(existingImageDetail);
        }

    }

    const incrementChangesCount = () => {
        setChangesCount(++changesCount);
    }

    const resetChangesCount = () => {
        setChangesCount(0);
    }

    return (
        <>

            <div className="flex justify-between mb-7">
                <div className="title-label">
                    {selectedImage?.fileName} <span
                    className="ml-2">({selectedImage?.width} x {selectedImage?.height} pixels)</span>
                </div>

                {selectedImage &&
                    <div className="float-right -mt-2">
                        <DeleteImage image={selectedImage} removeImage={removeImage}/>
                    </div>
                }
            </div>

            <div className="overflow-y-scroll form-container">

                {selectedImage &&
                    <>
                        <div>
                            <EditImageDetail
                                handleSelectImageChanges={handleSelectImageChanges}
                                allTags={allTags}
                                allThemes={allThemes}
                                imageDetail={selectedImage}/>
                        </div>

                        <div className="flex justify-center p-2 mt-8">

                            {!selectedImage?.fileUrl &&
                                <button type="button" className="border p-4 rounded bg-white h-full" disabled>
                                    <div className="flex items-center justify-center ">
                                        <div
                                            className="w-12 h-12 border-b-2 border-blue-900 rounded-full animate-spin"></div>
                                    </div>
                                </button>
                            }

                            {selectedImage?.fileUrl &&
                                <ShowImage src={selectedImage?.fileUrl}
                                           width={600} mode={'fit'}
                                           style={''}
                                           selectedImage={selectedImage}
                                           setImageSize={setImageSize}
                                           setSelectedImage={setSelectedImage}/>
                            }
                        </div>
                    </>
                }

            </div>
        </>
    )
}

export default ImageDetail
